import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Box,
} from "@mui/material";
import {
  Button,
  SaveButton,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  DateInput,
  SelectInput,
  Form,
  useRecordContext,
  useUpdate,
  useNotify,
  required,
  useGetIdentity,
  FormDataConsumer,
  useGetOne,
} from "react-admin";
import LaunchIcon from "@mui/icons-material/Launch";
import { Link } from "react-router-dom";

import FactCheckIcon from "@mui/icons-material/FactCheck";
const ScmFechamentoDialog = () => {
  const record = useRecordContext();
  const [update] = useUpdate();
  const notify = useNotify();
  const [showDialog, setShowDialog] = useState(false);
  const { identity } = useGetIdentity();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSave = async (values: any) => {
    const { parcelamentoFornec, ...valoresForm } = values;

    const payload = {
      // ...values,
      ...valoresForm,
      ordem_compra: {
        ...values.ordem_compra,
        // ...ordemCompra,
        parcelamento: parcelamentoFornec,
        gerar_oc: true,
      },
    };
    update(
      "scmanalyses",
      {
        id: record?.id,
        data: payload,
        previousData: record,
      },
      {
        onSuccess: () => {
          notify("Realizado Fechamento", { type: "info", undoable: false });
        },
        onError: (response: any) => {
          notify(`Error: ${response}`, { type: "error" });
        },
      }
    );
  };

  const optionCompaniesRenderer = (choice: any) =>
    `${choice.id} - ${choice.nome_reduzido}`;

  const optionSuppliersRenderer = (choice: any) =>
    `${choice.id} - ${choice.nome_fornec}`;

  const optionCarriersRenderer = (choice: any) =>
    `${choice.id} - ${choice.nome_entregador}`;

  // const optionFornecedorRenderer = (choice: any) =>
  //   `${choice?.nome_fornec} ${typeof choice?.quant_skus !== "undefined" ? "(" + choice?.quant_skus + " SKUs)" : ""}`;

  // Define a URL base com base no cookie
  const baseUrl = identity?.homologacao
    ? "https://sandbox.rnge.com.br/app/index.html#/"
    : "https://app.rnge.com.br/#/";

  return (
    <>
      {!record?.numero_oc ? (
        <Button
          onClick={handleClick}
          label="Fechamento"
          /* Alex pediu para mudar no dia 25/04 na call com o Jardel. 5min depois, mudou de ideia. Retornado label */
          // label="GERAR OC"
          variant="outlined"
          size="medium"
        >
          <FactCheckIcon />
        </Button>
      ) : (
        <Link
          to={`${baseUrl}purchaseorders/${record?.numero_oc}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginTop: "0.5em",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          OC {record?.numero_oc} <LaunchIcon sx={{ marginTop: "-0.1em" }} />
        </Link>
      )}
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create post"
        maxWidth="lg"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      >
        <Form
          onSubmit={handleSave}
          defaultValues={{
            ordem_compra: { id_empresa: record?.id_empresa, parcelamento: "" },
          }}
        >
          <DialogTitle>Fechamento</DialogTitle>
          <DialogContent>
            <Stack display={{ md: "block", lg: "flex" }}>
              <Box display="flex" alignItems="center" mb={1}>
                <Box flex={1} mr={{ sm: "0.5em" }}>
                  <ReferenceInput
                    source="ordem_compra.cnpj_fornec"
                    reference="supplierissuers"
                    filter={{ id_analise: record?.id }}
                  >
                    <AutocompleteInput
                      validate={required()}
                      optionText={optionSuppliersRenderer}
                      filterToQuery={(pesquisa) => ({ pesquisa })}
                      label="Fornecedor"
                    />
                  </ReferenceInput>
                </Box>
                <Box flex={1} mr={{ sm: "0.5em" }}>
                  <ReferenceInput
                    label="Empresa Destino"
                    source="ordem_compra.id_empresa"
                    reference="companies"
                    perPage={100}
                    sort={{ field: "id", order: "ASC" }}
                    filter={{ todas: true }}
                    fullWidth
                  >
                    <SelectInput
                      optionText={optionCompaniesRenderer}
                      label="Empresa"
                      validate={required()}
                      InputLabelProps={{ shrink: true }}
                    />
                  </ReferenceInput>
                </Box>
              </Box>
              <Box display="flex" alignItems="center" mb={1}>
                <FormDataConsumer>
                  {({ formData }) => {
                    const cnpjFornec = formData?.ordem_compra?.cnpj_fornec;
                    // Tive que fazer um GET para armazenar o retorno da API
                    const { data: fornecedor } = useGetOne(
                      "supplierissuers",
                      { id: cnpjFornec },
                      { enabled: !!cnpjFornec }
                    );

                    return (
                      <Box flex={1} mr={{ sm: "0.5em" }}>
                        <TextInput
                          source="parcelamentoFornec"
                          InputLabelProps={{ shrink: true }}
                          defaultValue={fornecedor?.prazo_pagamento} // pega do fornecedor
                        />
                      </Box>
                    );
                  }}
                </FormDataConsumer>
                <Box flex={1} mr={{ sm: "0.5em" }}>
                  <TextInput
                    source="ordem_compra.fat_previsto"
                    label="Previsão Faturamento"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              </Box>
              <Box display="flex" alignItems="center" mb={1}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <SelectInput
                    label="Modalidade Frete"
                    source="ordem_compra.mod_frete"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    choices={[
                      {
                        id: "0",
                        name: "0. Contratação do Frete por conta do Remetente (CIF)",
                      },
                      {
                        id: "1",
                        name: "1. Contratação do Frete por conta do Destinatário (FOB)",
                      },
                      {
                        id: "2",
                        name: "2. Contratação do Frete por conta de Terceiros",
                      },
                      {
                        id: "3",
                        name: "3. Transporte Próprio por conta do Remetente",
                      },
                      {
                        id: "4",
                        name: "4. Transporte Próprio por conta do Destinatário",
                      },
                      { id: "9", name: "9. Sem Ocorrência de Transporte" },
                    ]}
                  />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <FormDataConsumer>
                    {({ formData }) => (
                      <ReferenceInput
                        source="ordem_compra.id_entregador"
                        reference="carriers"
                        sort={{ field: "nome_entregador", order: "ASC" }}
                        fullWidth
                        filter={{ dias_transp: 180 }}
                      >
                        <AutocompleteInput
                          disabled={formData.ordem_compra.mod_frete !== "1"}
                          // validate={required()}
                          optionText={optionCarriersRenderer}
                          filterToQuery={(pesquisa) => ({ pesquisa })}
                          label="Transportadora"
                        />
                      </ReferenceInput>
                    )}
                  </FormDataConsumer>
                </Box>
              </Box>
              <Box display="flex" alignItems="center" mb={1}>
                <TextInput
                  source="ordem_compra.observacoes_oc"
                  label="Observações"
                  multiline
                  InputProps={{
                    style: { height: 100 },
                  }}
                />
              </Box>
            </Stack>
          </DialogContent>
          <DialogActions>
            <SaveButton label="Gerar OC Rascunho" type="submit" />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
};

export default ScmFechamentoDialog;
